<template>
  <div class="password">
    <div class="item">
      <div class="left"><span class="star">*</span>旧密码：</div>
      <a-input-password
        v-model="password1"
        placeholder="请输入旧密码"
        class="input-common"
      />
    </div>

    <div class="item">
      <div class="left"><span class="star">*</span>新密码：</div>
      <a-input-password
        v-model="password2"
        placeholder="请填写新密码"
        class="input-common"
      />
    </div>

    <div class="item">
      <div class="left"><span class="star">*</span>确认密码：</div>
      <a-input-password
        v-model="password3"
        placeholder="请填写确认密码"
        class="input-common"
      />
    </div>

    <div class="button submit" @click="submit">保存修改</div>
  </div>
</template>

<script>
import { isPassword } from "@/utils/validate";

export default {
  data() {
    return {
      password1: "",
      password2: "",
      password3: "",
      loading: false,
    };
  },

  methods: {
    submit() {
      if (!this.password1) {
        this.$message.error("请输入旧密码");
        return;
      }
      if (!isPassword(this.password2)) {
        this.$message.error("请输入8-16位数字、字母或符号组成的密码");
        return;
      }
      if (this.password3 !== this.password2) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      if (this.loading) return;
      this.loading = true;
      const zyzid = localStorage.getItem("jz_vol_zyzid");
      this.$api.vmsapi
        .updatePassword({
          oldpassword: this.password1,
          password: this.password2,
          zyzid: zyzid,
        })
        .then((res) => {
          if (res.status) {
            this.$message.success("密码修改成功，下次登录请使用新密码进行登录");
            this.password1 = "";
            this.password2 = "";
            this.password3 = "";
          } else {
            this.$message.info(res.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.password {
  width: 370px;
  margin: 0 auto;
  padding-top: 100px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .left {
      width: 120px;
      font-size: 14px;
      font-family: Helvetica;
      color: #999999;
      line-height: 17px;
      text-align: left;
      white-space: nowrap;
      .star {
        color: #ff0000;
        margin-right: 5px;
      }
    }
    .input-common {
      font-size: 14px;
      font-family: Helvetica;
      height: 36px;
    }
  }

  .button {
    height: 36px;
    border-radius: 2px;
    margin-bottom: 126px;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Helvetica;
  }
  .submit {
    background: #cd3232;
    color: #ffffff;
  }
}
</style>